import { Booking } from "shared-types"
import { Table, TableColumn } from "../../../Common/Components/BaseComponents/Table"
import { useBookingStore } from "../../../Stores/Workspace/bookingStore"
import { useEffect, useState } from "react"
import { showAlert } from "../../../Common/Components/BaseComponents/ShowAlert"
import Swal from "sweetalert2"
import { useNavigate } from "react-router-dom"
import { Button } from "../../../Common/Components/BaseComponents/Button"
import { PageContainer } from "../../../Common/Components/BaseComponents/PageContainer"
import { WithPermission } from "../../../Common/Components/WithPermission";

export const BookingTable = () => {
    const { bookings, getAllBookings, deleteBooking, bookingApproval } = useBookingStore()
    const [isLoading, setIsLoading] = useState(false);
    const allBookingFields: (keyof Booking)[] = [
        'roomName', 'customerName', 'externalUserName', 'externalUserEmail', 'externalUserPhone',
        'startTime', 'endTime', 'status', 'totalHours', 'totalCharge', 'chargeableHours'
    ];
    const navigate = useNavigate();
// תרגום לתצוגה בלבד
    const fieldLabels: Partial<Record<keyof Booking, string>> = {
        roomName: 'שם חדר',
        customerName: 'שם לקוח',
        externalUserName: 'שם משתמש חיצוני',
        externalUserEmail: 'אימייל משתמש חיצוני',
        externalUserPhone: 'טלפון משתמש חיצוני',
        startTime: 'שעת התחלה',
        endTime: 'שעת סיום',
        status: 'סטטוס',
        totalHours: 'סך שעות',
        totalCharge: 'סה"כ חיובים',
        chargeableHours: 'שעות לחיוב',
        approvedBy: 'מאושר על ידי',
        id: 'מזהה'
    };
    const getFieldLabel = (field: keyof Booking): string => {
        return fieldLabels[field] || field;
    };
    const columns: TableColumn<Booking>[] = [
        ...allBookingFields.map(field => ({
            header: getFieldLabel(field), // תצוגה בעברית
            accessor: field,           // הנתונים באנגלית
        })),
        {
            header: getFieldLabel('approvedBy'),
            accessor: 'approvedBy' as keyof Booking,
            render: (value: any, row: Booking) => (
                <>
                    { row.status !== 'APPROVED' && (
                        < WithPermission userRole="ADMIN" allowedRoles={ ["ADMIN"] }>
                            <Button
                                className="text-blue-500"
                                onClick={ () => handleApproval(row) }
                            >
                                לאישור
                            </Button>
                        </WithPermission>

                    ) }
                    { (row.status === 'APPROVED' && row.approvedBy) ? row.approvedBy : '' }
                </>
            )
        }
    ];
    useEffect(() => {
        const fetchData = async () => {
            if (bookings.length === 0) {
                console.log("calling getAllBookings");
                setIsLoading(true);
                await getAllBookings();
                console.log(" Bookings" + bookings);
                setIsLoading(false);
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const validBookings = bookings.filter(booking =>
        booking?.id &&
        (booking.roomName?.trim() || booking.customerName?.trim() || booking.externalUserName?.trim())
    );
//מחיקת הזמנה 
    const handleDelete = async (booking: Booking) => {
        const result = await Swal.fire({
            text: `האם ברצונך למחוק את ההזמנה של ${ booking.customerName || booking.externalUserName }?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'מחק',
            cancelButtonText: 'ביטול',
            reverseButtons: false
        });
        if (result.isConfirmed) {
            try {
                await deleteBooking(booking.id!);
                showAlert('נמחק בהצלחה!', 'ההזמנה נמחקה מהמערכת', 'success');
            } catch (error) {
                console.error('Error deleting booking:', error);
                showAlert('שגיאה!', 'אירעה שגיאה במחיקת ההזמנה', 'error');
            }
        }
    };
    //אישור הזמנה
    const handleApproval = async (booking: Booking) => {
        const result = await Swal.fire({
            title: 'אישור הזמנה',
            text: `האם ברצונך לאשר את ההזמנה של ${ booking.customerName || booking.externalUserName }?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'אשר',
            cancelButtonText: 'ביטול'
        });

        if (result.isConfirmed) {
            try {
                const approvedBooking = await bookingApproval(booking.id!);
                console.log('תשובה מהפונקציה:', JSON.stringify(approvedBooking, null, 2));
                await getAllBookings();
                if (approvedBooking) {
                    showAlert('אושר בהצלחה!',
                        `ההזמנה של ${ booking.customerName || booking.externalUserName } אושרה`, 'success');
                }
            } catch (error) {
                showAlert('שגיאה!', 'אירעה שגיאה באישור ההזמנה', 'error');
            }
        }
    };
//עדכון הזמנה
    const handleUpdate = (booking: Booking) => {
        navigate(`/updateBooking`, { state: { booking } });
        console.log('Update booking:', booking);
    };


    return <PageContainer title="הזמנות" maxWidth="7xl">
        { isLoading && <h2>טוען...</h2> }

        { !isLoading && <>
            <Button onClick={ () => navigate('/workspace/meetingRooms') }>להוספת הזמנה חדשה</Button>
            <Table<Booking>
                columns={ columns }
                data={ validBookings }
                onUpdate={ handleUpdate }
                onDelete={ handleDelete }
                className="shadow-lg"
            /></> }
    </PageContainer>
}